export const tms = {

    TSession: "session",
    MSessionLogin: "login",
    MSessionLogout: "logout",
    MSessionSaveBrowserFinger: "save_browser_finger",

    TVisit: "visit",
    MVisitGetMobileRegCode: "getMobileRegCode",
    MVisitAppStart: "appStart",
    MVisitAppFirstVisit: "appFirstVisit",

    TLogger: "logger",
    MLoggerCreate: "create",

    TTracking: "tracking",
    MTrackingGetVisitKey: "getVisitKey",
	MTrackingPrint : "print",

    TUser: "user",
    MUserGetUserInfo: "getUserInfo",
    MUserCreateRegCode: "createRegCode",
    MUserLoginByCode: "loginByCode",
    MUserLogout: "logout",
    MUserLoginByGoogle: "loginByGoogle",
    MUserLoginByEmail: "loginByEmail",
    MUserLoginByPw: "loginByPw",
    MUserUpdatePw: "updatePw",
	MUserDeleteAccount : "deleteAccount",

    TAuth: "auth",
    MAuthRefreshToken: "refreshToken",

    TDevice: "device",
    MDeviceReport: "report",
    
    TUserDevice: "user_device",
    MUserDeviceBindUser: "bind_user",
    MUserDeviceUnbindUser: "unbind_user",

    TEmc: "emergency-call",
    MEmcAddContact: "addContact",
    MEmcInviteContacts: "inviteContacts",
    MEmcListContacts: "listContacts",
    MEmcDeleteContact: "deleteContact",
    MEmcHandleInvite: "handleInvite",
    MEmcListInvites: "listInvites",
    MEmcGetContactDetail: "getContactDetail",
	MEmcRespondToInvite: "respondToInvite",  
    MEmcGetContactTypes: "getContactTypes",
    MEmcGetInviteStatus: "getInviteStatus",
    MEmcListAllInvitations : "list_all_invitations", // 获取所有相关的邀请列表（发出和收到）
    MEmcListEstablishedContacts : "list_established_contacts", // 获取已建立的联系人关系列表
    MEmcRemoveEstablishedContact : "remove_established_contact", // 解除已建立的联系人关系
    MEmcListPendingReceivedInvitations : "list_pending_received_invitations", // 获取未处理的被邀请信息

    TEventCall: "event-call", // 紧急呼叫事件处理
    MEventCallListAvailableMeetings: "listAvailableMeetings", // 获取用户可参与的音视频会议
    
    TPermission: "permission", // 权限管理
    MPermissionGetRelatedPermissions: "getRelatedPermissions", // 获取相关用户权限状态

    TReport: "report", // 举报
    MReportSubmit: "submit", // 提交举报
    MReportGetMyList: "getMyList", // 获取我的举报列表

    // === Project 相关 ===
    TProject: "project",
    MProjectCreateProject: "createProject",
    MProjectCreateTrigger: "createTrigger",
    MProjectCreateAction: "createAction",
    MProjectCreateTriggerGroup: "createTriggerGroup",
    MProjectCreateActionGroup: "createActionGroup",
    MProjectCreateTriggerAction: "createTriggerAction",
    MProjectCreateTriggerActionGroup: "createTriggerActionGroup",
    MProjectGetByUlids: "getByUlids",
    MProjectUpdateTrigger: "updateTrigger",
    MProjectUpdateAction: "updateAction",
    MProjectUpdateTriggerGroup: "updateTriggerGroup",
    MProjectUpdateActionGroup: "updateActionGroup",
    MProjectUpdateTriggerAction: "updateTriggerAction",
    MProjectUpdateTriggerActionGroup: "updateTriggerActionGroup",
    MProjectUpdateProject: "updateProject",
    MProjectNextPage: "nextPage",
    MProjectListUserProjects: "listUserProjects",  // 查询个人项目列表（游标分页）
    MProjectDeleteProject: "deleteProject",  // 删除项目
    MProjectGetProjectR2Url: "getProjectR2Url",  // 获取public项目的project.json在R2的完整URL
    MProjectCloneProject: "cloneProject",  // 克隆public项目到自己的项目列表
    MProjectUpsertProject: "upsertProject",  // 创建或更新项目（合并接口）
}
